import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Col, Row, FormGroup, Input, Label } from 'reactstrap';
import moment from 'moment';
import MaterialIcon from "material-icons-react";
import i18n from "../../../../i18next";

import { loadDaysOff, updateDaysOff, resetDaysOff } from '../../../../actions/index';
import DaysOffModal from './DaysOffModal';

class DaysOffScreen extends Component {

    constructor(props) {
        super(props);
        // Get the current year
        let year = (new Date()).getFullYear();

        this.state = {
            restaurantId: null,
            year: year,
            months: this.getCalendarData(year),
            daysOff: [],
            stateAlreadyCopiedFromProps: false,
            modalOpened: false,
            selectedDate: null,
            selectedDay: null
        };

        this.changeYear = this.changeYear.bind(this);
    }

    componentWillMount() {
        let restaurantId = this.props.match.params.id;
        this.props.loadDaysOff(restaurantId);
    }

    componentWillUnmount() {
        this.props.resetDaysOff()
    }

    copyStateFromProps() {

        // TODO quick fix removed the condition not sure if it is ok not to be there
        if (this.props.daysOff !== undefined && this.props.daysOff !== null && this.props.daysOff.length &&
            !this.state.stateAlreadyCopiedFromProps) {
            // TODO we dont mutate the array but we make shallow copy of the objects this way it will mutate the objects in the store - lodash cloning of objects

            this.setState({
                ...this.state,
                daysOff: this.props.daysOff,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    changeYear({target}) {
        this.setState({
            ...this.state,
            months: this.getCalendarData(target.value)
        });
    }

    /* Prepare data for the calendar */
    getCalendarData(year) {
        let months = { "0": null, "1": null, "2": null, "3": null, "4": null, "5": null, "6": null, "7": null, "8": null, "9": null, "10": null, "11": null };

        for (let key in months) {
            let month = Number(key);
            months[key] = this.getDaysInMonth(year, month);
        }

        return months;
    }

    getDaysInMonth(year, month) {
        let date = new Date(year, month, 1);
        let days = [];

        while (date.getMonth() === month) {
            days.push(new Date(date));
            date.setDate(date.getDate() + 1);
        }

        return days;
    }

    getMonthName(month) {
        const monthNames = ["jan", "feb", "mar", "apr", "may", "jun",
            "jul", "aug", "sep", "oct", "nov", "dec"];

        return monthNames[month[0].getMonth()];
    }

    prependEmptyDate(monthContainer, daysUntilStartOfTheWeek) {
        while (daysUntilStartOfTheWeek > 0) {
            monthContainer.unshift(null);
            --daysUntilStartOfTheWeek;
        }

        return monthContainer;
    }

    addEmptyDate(monthContainer, daysUntilStartOfTheWeek) {
        while (daysUntilStartOfTheWeek > 0) {
            monthContainer.push(null);
            --daysUntilStartOfTheWeek;
        }

        return monthContainer;
    }

    prepareMonthTemplate(month) {
        let monthTemplate = month.map((date) => {
            return date;
        });

        const firstDayOfMonth = month[0].getDay();
        const lastDayOfMonth = month[month.length - 1].getDay();

        if (firstDayOfMonth !== 1 && firstDayOfMonth !== 0) {
            let daysUntilStartOfTheWeek = firstDayOfMonth - 1;

            monthTemplate = this.prependEmptyDate(monthTemplate, daysUntilStartOfTheWeek);
        }
        else if (firstDayOfMonth === 0) {

            let daysUntilStartOfTheWeek = 6;

            monthTemplate = this.prependEmptyDate(monthTemplate, daysUntilStartOfTheWeek);
        }

        if (lastDayOfMonth !== 0) {
            let daysUntilStartOfTheWeek = 7 - lastDayOfMonth;

            monthTemplate = this.addEmptyDate(monthTemplate, daysUntilStartOfTheWeek);
        }

        return monthTemplate;
    }
    /* Handle selected days adding/removing of days to the calendar */
    handleDateSelect(selectedDate, formattedDay) {
        this.setState({ ...this.state, selectedDate: selectedDate, selectedDay: formattedDay }, () => {
            this.toggleModal();
        });
    }

    saveDaysOff() {
        let restaurantId = this.props.match.params.id;
        this.props.updateDaysOff(this.state.daysOff, restaurantId);
    }
    /* Render methods for component */
    renderHeading() {
        const { screenHeading } = styles;

        return (
            <div style={screenHeading}>
                <MaterialIcon icon="event" color="#000" size={22} color="#0288d1" />&nbsp;
                {i18n.t('screens:restaurantsMainContainer.daysoff')}
            </div>
        );
    }

    toggleModal() {
        this.setState({
            modalOpened: !this.state.modalOpened
        });
    }

    renderMonth(month) {

        const { monthHeader, daysStyle, monthNameStyle } = styles;

        let monthName = this.getMonthName(month);

        return (
            <Col sm={4} style={monthHeader}>
                <h5 style={monthNameStyle}>{i18n.t(`common:months.${monthName}`)}</h5>

                <ul style={daysStyle}>
                    {this.renderDays(month)}
                </ul>
            </Col>
        );
    }

    renderDays(month) {

        const { dayBox, emptyBox } = styles;

        let monthData = this.prepareMonthTemplate(month);

        return monthData.map((date) => {

            let formattedDate = moment(date).format("DD-MM-YYYY");

            // Style days off and exception days differently
            let dayClass = '';
            let dateData = {};
            this.state.daysOff.map((dateObject) => {

                if (dateObject.day === formattedDate) {
                    dateData = dateObject;
                }

                if (dateObject.day === formattedDate && dateObject.exceptionDay === false) {
                    dayClass = 'bg-primary';
                } else if (dateObject.day === formattedDate && dateObject.exceptionDay) {
                    dayClass = 'bg-info';
                }
            });

            if (date === null) {
                return (
                    <li style={emptyBox}>1</li>
                );
            }
            return (
                <li style={dayBox} className={dayClass} onClick={() => { this.handleDateSelect(dateData, formattedDate) }}>{date.getDate()}</li>
            );
        });
    }

    removeDateFromState(dateObject) {
        return this.state.daysOff.filter((date) => {
            if (date.day !== dateObject.day) {
                return date;
            }
        });
    }

    applyDate(dateObject) {

        // check to see if we are in edit mode
        let editMode = false;
        this.state.daysOff.map((date) => {
            if (date.day === dateObject.day) {
                editMode = true;
            }
        });

        if (editMode) {
            let splicedDaysOff = this.removeDateFromState(dateObject);
            // Add the new date data in the array
            splicedDaysOff = splicedDaysOff.concat([dateObject]);

            // Set the state and save to db
            this.setState({ daysOff: splicedDaysOff }, () => {
                this.saveDaysOff();
            });

            return;
        }

        // We are NOT in edit mode so add to the daysOff and save to db
        this.setState({ daysOff: this.state.daysOff.concat([dateObject]) }, () => {
            this.saveDaysOff();
        });
    }

    deleteDate(dateObject) {
        // Remove the date from state
        let splicedDaysOff = this.removeDateFromState(dateObject);

        this.setState({ daysOff: splicedDaysOff }, () => { this.saveDaysOff() });
    }

    renderYear() {
        return (
            <FormGroup style={{ display: 'flex', flexDirection: 'row', paddingLeft: 30, minWidth: 240 }}>
                <Label style={{ display: 'flex', alignSelf: 'center', width: '70%', marginRight: 20 }}>{i18n.t('screens:restaurantsMainContainer.selectYear')}:</Label>
                <Input type='select' name='year' style={{ width: 100 }} onChange={this.changeYear}>
                    <option value={this.state.year}>{this.state.year}</option>
                    <option value={this.state.year + 1}>{this.state.year + 1}</option>
                </Input>
            </FormGroup>
        );
    }

    render() {
        const { containerStyle } = styles;
        this.copyStateFromProps();

        return (
            <Container fluid style={containerStyle}>
                <Row>
                    {this.renderHeading()}
                </Row>
                <Row>
                    {this.renderYear()}
                </Row>
                <Row>
                    {_.map(this.state.months, month => {
                        return this.renderMonth(month);
                    })}
                </Row>
                <br />

                <DaysOffModal
                    title={i18n.t('screens:restaurantsMainContainer.daysoff')}
                    selectedDate={this.state.selectedDate}
                    selectedDay={this.state.selectedDay}
                    isOpen={this.state.modalOpened}
                    onToggle={this.toggleModal.bind(this)}
                    onSave={this.applyDate.bind(this)}
                    onDelete={this.deleteDate.bind(this)}
                />
            </Container>
        );
    }
}

const mapStateToProps = state => {
    return {
        daysOff: state.daysOff
    };
};

export default connect(mapStateToProps, { loadDaysOff, updateDaysOff, resetDaysOff })(DaysOffScreen);

let styles = {
    containerStyle: {
        marginLeft: 15,
        marginBottom: 25,
        paddingTop: 10,
        paddingLeft: 0
    },
    monthHeader: {
        textAlign: 'center',
        marginBottom: 10
    },
    dayBox: {
        width: '13%',
        display: 'inline-block',
        height: 40,
        textAlign: 'right',
        border: '1px solid',
        borderColor: '#D8D8D8',
        paddingRight: 3,
        cursor: 'pointer'
    },
    emptyBox: {
        width: '13%',
        display: 'inline-block',
        height: 40,
        textAlign: 'right',
        border: '1px solid',
        borderColor: '#D8D8D8',
        paddingRight: 3,
        backgroundColor: '#EEEEEE',
        color: 'transparent'
    },
    daysStyle: {
        fontSize: 14,
        paddingLeft: 10
    },
    monthNameStyle: {
        fontSize: 16
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        paddingLeft: 0,
        color: '#0288d1',
        marginBottom: 20,
        marginLeft: 25,
        width: 299
    },
    spaceBetween: {
        paddingLeft: 4
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/restaurant/DaysOffScreen.js